<template>
  <div>
    <Header/>
    <Scroll/>
    <div>
      <div class="mall_pageTopWrap">
          <p class="mall_pageTopTit">Notice</p>
      </div>
      <div class="mall_arrC_Box mall_arrC_BoxPage">
        <div
          class="mall_arrC_contBox"
          v-for="item in statusData.newsData"
            :key="item.news_ID"
        >
          <a :href="'/NewsDetail?news_ID=' + item.news_ID">
            <p class="mall_arrC_img">
              <img
                :src="item.news_main_image"
                  :alt="item.recommend_banner_title"
              />
            </p>
            <div class="mall_arrC_txtBox">
              <p class="mall_arrC_txtBox_tit">{{item.news_title}}</p>
              <p>{{item.news_sub_title}}</p>
            </div>
          </a>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_news_use
} from '../../ETC/Axios.vue'

export default {
  name: 'News',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      statusData: ref({
        newsData: []
      })
    }
  },
  mounted () {
    get_news_use().then(result_data => {
      this.statusData.newsData = result_data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/News/News.vue